/**
 * forgot-password-page.tsx — placeholder until the backend exposes
 * /auth/forgot-password. Restyled in iltizam Phase 6 to match the
 * other auth surfaces.
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function ForgotPasswordPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="iltizam-card p-8">
      <h1 className="m-0 text-[28px] font-extrabold leading-tight text-iltizam-ink">
        {t('auth.forgot_password')}
      </h1>
      <p className="mt-1.5 text-[13px] text-iltizam-muted">
        {t('auth.forgot_password_unavailable')}
      </p>
      <p className="mt-4 text-[13px] text-iltizam-muted">
        {t('auth.forgot_password_contact_admin')}
      </p>
      <Link
        to="/auth/login"
        className="mt-6 inline-flex w-full items-center justify-center rounded-pill border border-iltizam-line bg-white px-4 py-2.5 text-[13px] font-bold text-iltizam-ink hover:bg-iltizam-warm"
      >
        {t('common.back')}
      </Link>
    </div>
  );
}
